<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
            @delete-item="deleteType"></view-item>

        <list-items v-else :title="$translate('customer_agents')" @show-item="showCustomerAgent" ref="table">
            <b-button id="add-customer-agent-btn" block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'CustomerAgents',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data: () => {
        return {
            item: null,
        }
    },

    computed: {
        componentName() { return this.$translate('customer_agent') },
        customerAgents() {
            const customerAgents = this.$store.state.customerAgents.customer_agents
            return customerAgents
        },
    },

    methods: {
        showCustomerAgent(id) {
            this.item = this.customerAgents.find(x => x.id === id)
        },

        resetItems(status, message) {
            console.log('deleteMessage',message);
            this.genericToast(this.componentName, status, 'success', `${this.componentName} ${message}`)
            this.item = null
        },
    },
}
</script>
<style></style>
